module.exports = __webpack_public_path__ + "static/media/web_page_articles.8a627ad1.png";